/*
  Хук для использования при активации модальных окон.
  activeModal - имя активной модалки
  activeModalOptions - дополнительные данные для отображения модалки. Необязательный параметр
*/

import { useState } from "react";
import { AnyObject } from "../interfaces/AnyObject";

// TODO Evgeniy Sumaev: Разорабраться как сделать чтобы типизировать activeModalOptions с учетом необязательности
export type SetActiveModal<P> = (activeModal: P, activeModalOptions?: AnyObject) => void;

export const useActiveModal = <T>(activeModal: T, activeModalOptions?: AnyObject) => {
  const [data, setData] = useState<{
    activeModal: T;
    activeModalOptions?: AnyObject;
  }>({
    activeModal,
    activeModalOptions,
  });

  const setActiveModal: SetActiveModal<T> = (activeModal, activeModalOptions) => {
    setData({
      activeModal,
      activeModalOptions,
    });
  };

  return { ...data, setActiveModal };
};
